module.exports = __webpack_public_path__ + "punch.svg?bf94157a593715716d50f1a5dafae9ce";